import React, { useState } from 'react';
import { Modal, Button, Form, Input } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { sendEmail } from 'Redux/actions/sendEmailAction';

export function success(response) {
  var content = 'Cotización enviada con éxito';
  if (response.have_sms_sender) {
    if (Object.keys(response.errors).length > 0) {
      content = 'Email enviado con éxito.\nFalló al enviar mensaje de texto.'
    }
  }
  Modal.success({
    content: content,
  });
}

export function error(response) {
  var content = 'Ocurrio un error al enviar la cotización';
  if (response.status_code == 404) {
    content = response.errors[0];
  }
  Modal.error({
    content: content,
  });
}

const modalSendEmail = (props) => {

  const { visible, handleCancel, title, label, placeholder, sendEmail, idQuotation, isLoading } = props;
  const [form] = Form.useForm();
  const [stateEmail, setStateEmail] = useState({ emailsIsValid: false, emailsErros: [] });
  // const [isLoading, setLoading] = useState(false);

  const onSubmit = async () => {
    // validate emails
    const values = await form.validateFields();

    const emails = values.emails.split(',');

    const emailsErros = emails.filter((email) => email.length)
      .map((email) => {
        if (email.length) {
          const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
          return {
            email,
            isValid: emailRegex.test(email),
          };
        }
      });

    let emailsIsvalid = true;
    for (let email in emailsErros) {
      emailsIsvalid = emailsErros[email].isValid && emailsIsvalid;
    };

    setStateEmail({ emailsIsValid: emailsIsvalid, emailsErros });

    // invok callback
    if (emailsIsvalid) {
      // handleOk(emails)
      sendEmail({ emails, idQuotation }).then((response) => {
        success(response);
        handleCancel();
      }).catch((response) => {
        error(response);
        handleCancel();
      });
    }
  };

  const handleOnchangeEmails = (e) => {
    const emailsValues = e.target.value;
    const newEmails = emailsValues.replace(/ /g, ',');
    form.setFieldsValue({ emails: newEmails });
  };

  return (
    <Modal
      title={title}
      visible={visible}
      onCancel={handleCancel}
      maskClosable={false}
      footer={[
        <Button key="back" onClick={handleCancel}>Cerrar</Button>,
        <Button key="submit" type="primary" loading={isLoading} onClick={onSubmit} >Enviar</Button>,
      ]}
    >
      <Form
        layout="vertical"
        form={form}>
        <Form.Item
          rules={[{ required: true, message: 'E-mial/e-mails es requerido' }]}
          style={{ marginBottom: 0 }}
          name="emails"
          label={label}>
          <Input onChange={handleOnchangeEmails} type="email" placeholder={placeholder} />
        </Form.Item>

      </Form>
      {
        stateEmail.emailsErros.filter((email) => !email.isValid)
          .map((item, key) => {
            return <div key={key}><span style={{ color: 'red', fontSize: 13 }}>E-mail no válido {item.email}</span></div>;
          })
      }
    </Modal>
  );
};

modalSendEmail.propTypes = {
  visible: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func,
  title: PropTypes.any.isRequired,
  label: PropTypes.any.isRequired,
  placeholder: PropTypes.any.isRequired,
  sendEmail: PropTypes.any.isRequired,
  idQuotation: PropTypes.any,
  isLoading: PropTypes.any.isRequired,
};

const actions = {
  sendEmail,
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.sendEmailQuotation.requestState.isFeching,
  };
};
export default connect(mapStateToProps, actions)(modalSendEmail);
